/**
 * TROOP-565/699: Optionswerte auf der PDP numerisch / alphabetisch sortieren.
 * Nur für Optionen mit data-option-sort="natural" (siehe cheveyo-option-sort-mode.liquid).
 */
(function () {
  function parseLeadingNumber(value) {
    const match = String(value).trim().match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  function isSorted(values, compare) {
    for (let i = 1; i < values.length; i += 1) {
      if (compare(values[i - 1], values[i]) > 0) return false;
    }
    return true;
  }

  function shouldSortContainer(container) {
    return container?.dataset?.optionSort === 'natural';
  }

  function sortRadioFieldset(fieldset) {
    if (!shouldSortContainer(fieldset)) return;

    const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
    if (inputs.length < 2) return;

    const numbers = inputs.map((input) => parseLeadingNumber(input.value));
    const allNumeric = numbers.every((n) => n !== null);

    if (
      allNumeric &&
      isSorted(
        numbers,
        (a, b) => a - b
      )
    ) {
      return;
    }

    if (
      !allNumeric &&
      isSorted(
        inputs.map((input) => input.value),
        (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })
      )
    ) {
      return;
    }

    const pairs = inputs.map((input) => ({
      input,
      label: fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`),
      value: input.value,
      sortKey: allNumeric ? parseLeadingNumber(input.value) : input.value,
    }));

    pairs.sort((a, b) => {
      if (allNumeric) return a.sortKey - b.sortKey;
      return String(a.sortKey).localeCompare(String(b.sortKey), undefined, { sensitivity: 'base' });
    });

    pairs.forEach(({ input, label }) => {
      fieldset.appendChild(input);
      if (label) fieldset.appendChild(label);
    });
  }

  function sortSelectOptions(select) {
    const container = select.closest('[data-option-sort]');
    if (!shouldSortContainer(container)) return;

    const options = [...select.options];
    if (options.length < 2) return;

    const numbers = options.map((option) => parseLeadingNumber(option.value));
    const allNumeric = numbers.every((n) => n !== null);

    options.sort((a, b) => {
      if (allNumeric) return parseLeadingNumber(a.value) - parseLeadingNumber(b.value);
      return a.value.localeCompare(b.value, undefined, { sensitivity: 'base' });
    });

    options.forEach((option) => select.appendChild(option));
  }

  function sortVariantOptionGroups(root = document) {
    root.querySelectorAll('variant-selects').forEach((variantSelects) => {
      variantSelects.querySelectorAll('fieldset.product-form__input').forEach(sortRadioFieldset);
      variantSelects.querySelectorAll('select.select__select').forEach(sortSelectOptions);
    });
  }

  document.addEventListener('DOMContentLoaded', () => sortVariantOptionGroups());

  document.addEventListener('shopify:section:load', (event) => {
    sortVariantOptionGroups(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      sortVariantOptionGroups();
    });
  }
})();
